export const CREATE_QUALIFICATION = "CREATE_QUALIFICATION";
export const FETCH_QUALIFICATIONS = "FETCH_QUALIFICATIONS";
export const FETCH_QUALIFICATION = "FETCH_QUALIFICATION";
export const EDIT_QUALIFICATION = "EDIT_QUALIFICATION";
export const DELETE_QUALIFICATION = "DELETE_QUALIFICATION";
